<script setup lang="ts">
defineProps({
    isMenuMobileOpen: {
        type: Boolean,
        required: true,
    },
})
defineEmits(['toggleMobileMenu'])

const classDiv = 'h-[2px] rounded bg-plus-lp-grey-100 transition-all duration-200 ease-linear'
const classMenuOpen = 'absolute left-0 top-0 w-[17px]'
</script>

<template>
    <div
        class="flex cursor-pointer items-center gap-3 pl-4"
        @click="$emit('toggleMobileMenu')"
    >
        <span>Menu</span>
        <div class="flex w-5 items-center">
            <div class="relative flex flex-col gap-1">
                <div :class="[isMenuMobileOpen ? `${classMenuOpen} -rotate-45` : 'w-5', classDiv]" />
                <div :class="[isMenuMobileOpen ? `${classMenuOpen} rotate-45` : 'w-4', classDiv]" />
            </div>
        </div>
    </div>
</template>
